











































































import SelectWithFilter from '@/components/SelectWithFilter.vue'
import { Component, Mixins, Prop } from 'vue-property-decorator'
import Modal from '@/layouts/Modal.vue'
import { CatchValidationErrorsMixin, UwInput } from '@ultraware/vee-form-handler'
import { createSchoolCredit, ISchool, ISchoolCredit, readSchools } from '../store/school-credit'
import { IArticle, readArticles } from '../store/article'
import { IVxsPromise, vxsActionFetch, vxsActionSend, vxsDataGetter } from 'vuex-xhr-state'
import { QDate, QIcon, QPopupProxy, QTooltip } from 'quasar'
import { IQSelectOptions } from '@ultraware/vue-helpers/dist/types/quasar-types'
import { ValidationObserver } from 'vee-validate'
import { transformDateToISO } from '@/domains/date'

@Component({
  components: { SelectWithFilter, Modal, QDate, QIcon, QPopupProxy, QTooltip, UwInput, ValidationObserver },
})
export default class SchoolCreditCreateModal extends Mixins(CatchValidationErrorsMixin) {
  @vxsActionFetch(readArticles) public fetchArticles!: () => IVxsPromise<IArticle>
  @vxsDataGetter(readArticles) public getArticles!: () => IArticle[]
  @vxsActionSend(createSchoolCredit) private createSchoolCredit !: (payload: object) => IVxsPromise<void>
  @vxsActionFetch(readSchools) public fetchSchools!: () => IVxsPromise<ISchool[]>
  @vxsDataGetter(readSchools) public getSchools!: () => ISchool[]
  @Prop({ required: true, type: Boolean }) public value!: boolean

  public startDate = ''
  public editSchoolCredit: ISchoolCredit = {
    product_uid: '',
    title: '',
    organisation_id: '',
    school_name: '',
    amount: 0,
    start_date: '',
  }

  public async submit(): Promise<void> {
    const result = await this.$refs.validationObserver.validate()
    if (!result) return

    this.editSchoolCredit.start_date = transformDateToISO(this.startDate)
    this.createSchoolCredit(this.editSchoolCredit)
      .then(() => {
        this.$emit('success')
        this.open = false
      })
      .catch(this.catchValidationErrors)
  }

  public created(): void {
    this.fetchArticles()
    this.fetchSchools()
    this.resetFormFields()
  }

  get open(): boolean {
    return this.value
  }

  set open(v: boolean) {
    this.$emit('input', v)
  }

  public close(): void {
    this.open = false
    this.resetFormFields()
  }

  get schoolOptions(): IQSelectOptions[] {
    return [...this.getSchools()].sort((a: ISchool, b: ISchool) => {
      const schoolnameA = a.name.toUpperCase()
      const schoolnameB = b.name.toUpperCase()

      if (schoolnameA > schoolnameB) return 1
      if (schoolnameA < schoolnameB) return -1

      return 0
    }).map((v: ISchool): IQSelectOptions => {
      return {
        label: v.name,
        value: v.id,
      }
    })
  }

  get productSelection(): IQSelectOptions[] {
    return [...this.getArticles()].sort((a: IArticle, b: IArticle) => {
      const titleA = a.Title.toUpperCase()
      const titleB = b.Title.toUpperCase()

      if (titleA > titleB) return 1
      if (titleA < titleB) return -1

      return 0
    }).map((v: IArticle): IQSelectOptions => {
      return {
        label: v.ProductId + ' - ' + v.Title,
        value: v.ProductId,
      }
    })
  }

  public resetFormFields(): void {
    this.startDate = ''
    this.editSchoolCredit = {
      product_uid: '',
      title: '',
      organisation_id: '',
      school_name: '',
      amount: 0,
      start_date: '',
    }
  }
}
